var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-body-content"},[_c('ul',{staticClass:"menu-wrap"},_vm._l((_vm.menuItem),function(item,index){return _c('li',{key:index,class:['normalMenu' , {'activeMenu': _vm.activeIndex == item.name} ],attrs:{"index":item.name},on:{"click":function($event){return _vm.handleSelect(item.name)}}},[_vm._v(_vm._s(item.title))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d0a9340","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/menu.vue
// module id = null
// module chunks = 